import React from 'react';
import { ListItem, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { List } from '@popmenu/admin-ui';

import type { UserUnsubscribedRestaurantsProps } from './interfaces';

const UserUnsubscribedRestaurants = ({ user }: UserUnsubscribedRestaurantsProps) => {
  const unsubscribedCount = user.emailUnsubscribedRestaurants.length;
  const followerCount = user.followers.length;
  const unsubscribedFromAllRestaurants = followerCount > 0 && followerCount === unsubscribedCount;

  return (
    unsubscribedFromAllRestaurants ? (
      <Typography>
        <FormattedMessage defaultMessage="You have been unsubscribed from all restaurants" />
      </Typography>
    ) : (
      <Typography>
        <FormattedMessage defaultMessage="You have been unsubscribed from the following restaurants:" />
        <List>
          {user.emailUnsubscribedRestaurants.map(restaurant => <ListItem>{restaurant.name}</ListItem>)}
        </List>
      </Typography>
    )
  );
};

export default UserUnsubscribedRestaurants;
